export default "__VITE_ASSET__10674630__"